<template>
  <div class="pt-safe bg-topbar-background border-b border-content-background">
    <div class="px-2 sm:px-4 py-2 sm:py-3 flex text-n-0 items-center h-14">
      <div class="flex-1 flex items-center shrink min-w-0">
        <div class="shrink-0 flex m-2">
          <img src="/icon.png" class="h-7 w-7" />
        </div>
      </div>
      <div class="flex justify-center">
        <l-option-selector v-model="screenConfig.filter" :options="filterList" class="w-80" />
      </div>
      <div class="flex-1 flex justify-end text-n-0 items-center sm:gap-2">
        <l-button
          v-if="!isConnected"
          icon="lucide/wifi-off"
          size="small"
          color="red"
          class="rounded-full"
        />
        <div class="px-3 text-lg font-semibold text-n-0 tabular-nums tracking-wide">
          {{ format(time, 'HH:mm:ss') }}
        </div>
        <div class="p-3 cursor-pointer" @click="showMenu = true">
          <l-icon name="lucide/menu" size="medium" />
        </div>
      </div>
    </div>

    <side-menu :open="showMenu" @close="showMenu = false" />
  </div>
</template>

<script setup lang="ts">
import { useNow } from '@vueuse/core'
import { format } from 'date-fns'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { LButton, LIcon, LOptionSelector } from '@last/core-ui/paprika'

import SideMenu from '@/modules/SideMenu.vue'
import { useConfigStore } from '@/store/config'
import { useKitchenOrderStore } from '@/store/kitchenOrders'
import { useStatusStore } from '@/store/status'

const time = useNow({
  interval: 1_000
})

const { t } = useI18n()

const kitchenOrderStore = useKitchenOrderStore()
const configStore = useConfigStore()
const { mappedKitchenOrders } = storeToRefs(kitchenOrderStore)
const { selectedPrinterId, screenConfig } = storeToRefs(configStore)

const { isConnected } = storeToRefs(useStatusStore())

const showMenu = ref(false)

const openTicketsCount = computed(() => {
  return Object.values(mappedKitchenOrders.value).filter(order => {
    const isSelectedPrinter =
      selectedPrinterId.value !== 'all' ? order.printerId === selectedPrinterId.value : true
    const isDone = order.status === 'completed' || order.status === 'cancelled'
    return isSelectedPrinter && !isDone
  }).length
})

const filterList = computed(() => [
  {
    label: `${openTicketsCount.value} ${t('filter.open')} `,
    value: 'open'
  },
  {
    label: t('filter.closed'),
    value: 'closed'
  }
])
</script>
